import React from "react";
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import useClientPlants from "../../../../../../../../hooks/useClientPlants";
import NumberedTitle from "../shared/NumberedTitle";
import DocReviewer from "../../../../DCSTab/DocReviewer";

export default function VendorDataReq() {
  const { plantId } = useParams();
  const { plants } = useClientPlants();
  const plant = plants.find((p) => String(p.id) === String(plantId)) || {
    id: plantId,
  };

  return (
    <Box>
      <NumberedTitle number="4" title="Vendor Data Requirements" />
      {/* Show DCS Doc Reviewer filtered to Vendor documents for this plant */}
      <Box mt={2}>
        <DocReviewer
          plant={plant}
          initialType="Vendor"
          hideTypeSelector={true}
        />
      </Box>
    </Box>
  );
}
